import { ReactElement } from 'react'
import { useFormContext, useFormState } from 'react-hook-form'
import { RestoreLoadingButton } from '@ui/actions'
import { CheckSettingsFormValues } from '../types'

interface Props {
  disabled?: boolean
}

/**
 * Discards the staged settings and the utilization preview they produced by
 * resetting the form to the members' saved values. Clearing `dirtyFields` also
 * releases the block registered by CheckSettingsDirtyBlocker, so the user can
 * switch tabs straight afterwards.
 */
const CheckSettingsResetButton = <SharedSettings = SettingsOnMember,>({
  disabled = false,
}: Props): ReactElement => {
  const { reset } = useFormContext<CheckSettingsFormValues<SharedSettings>>()
  const { dirtyFields } = useFormState<CheckSettingsFormValues<SharedSettings>>()

  return (
    <RestoreLoadingButton
      variant="outlined"
      size="small"
      fullWidth
      disabled={disabled || !dirtyFields.sharedSettings}
      onClick={() => reset()}
      data-cy="check-settings-reset-button"
    >
      Zurücksetzen
    </RestoreLoadingButton>
  )
}

export default CheckSettingsResetButton
